import { StaffActivitiesByDescription } from "../../types";

// TODO - callbacks present in original version of Maine Certification Letter
export const staffActivities: StaffActivitiesByDescription = {
  "Maine Certification Letter - Subject to Emergency Planning": {
    parameters: {
      linkUrls: [
        {
          name: "Certification Letter (required if facility is subject to emergency planning)",
          link: "https://drive.google.com/file/d/1YwT_M0Ni8W21GTS38S16Z9kH95KCT8ZS/view",
        },
        {
          name: "Fee Sheet",
          link: "https://docs.google.com/spreadsheets/d/1BautUWM7Yu2_ATh6TX00o3Ll9on7PVWl/edit?gid=1987794947#gid=1987794947",
        },
      ],
      staffInputs: {
        fees: true,
        documentTypes: {
          feeCalculation: true,
          certification: true,
        },
      },
    },
    jurisdictionType: "State",
    state: "ME",
  },
  "Maine Certification Letter - Not Subject to Emergency Planning": {
    parameters: {
      linkUrls: [
        {
          name: "Fee Sheet",
          link: "https://docs.google.com/spreadsheets/d/1BautUWM7Yu2_ATh6TX00o3Ll9on7PVWl/edit?gid=1987794947#gid=1987794947",
        },
      ],
      staffInputs: {
        fees: true,
        documentTypes: {
          feeCalculation: true,
        },
      },
    },
    jurisdictionType: "State",
    state: "ME",
  },
};
